import React from "react";

export default function Privacy() {
    return (
        <section className="max-w-3xl mx-auto px-5 md:px-10 py-16 md:py-24" data-testid="privacy-page">
            <p className="bc-label-small">Confidentialité</p>
            <h1 className="font-serif text-[#D4BC7C] text-4xl sm:text-5xl mt-4">Politique de confidentialité</h1>
            <div className="bc-hairline-gold my-6" />

            <div className="prose prose-invert text-[#F2ECE0]/85 leading-relaxed space-y-6 max-w-none">
                <p className="text-sm text-[#A0A0A0]">Dernière mise à jour : {new Date().toLocaleDateString("fr-CH")}</p>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">1. Responsable du traitement</h2>
                <p>
                    Le responsable du traitement des données personnelles est la Boucherie Costa, sise à
                    Yverdon-les-Bains, Suisse. Pour toute question relative à vos données, vous pouvez nous
                    contacter directement.
                </p>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">2. Données collectées</h2>
                <p>Dans le cadre de l'Espace Pro, nous collectons uniquement les données strictement nécessaires :</p>
                <ul className="list-disc list-inside space-y-2">
                    <li>Nom, prénom, e-mail professionnel, téléphone</li>
                    <li>Raison sociale, numéro IDE/TVA, fonction</li>
                    <li>Mot de passe (stocké de manière sécurisée par hachage bcrypt, jamais en clair)</li>
                    <li>Date de création du compte et journal des connexions</li>
                </ul>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">3. Finalités</h2>
                <p>Vos données sont utilisées exclusivement pour :</p>
                <ul className="list-disc list-inside space-y-2">
                    <li>Vérifier la qualité de client professionnel</li>
                    <li>Vous donner accès aux tarifs professionnels et aux suggestions</li>
                    <li>Communiquer avec vous concernant vos commandes</li>
                    <li>Respecter nos obligations légales et comptables</li>
                </ul>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">4. Base légale</h2>
                <p>
                    Le traitement repose sur l'exécution du contrat professionnel, votre consentement explicite
                    (lors de l'inscription), et le respect de nos obligations légales suisses (nLPD) et
                    européennes (RGPD/GDPR) lorsqu'applicables.
                </p>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">5. Hébergement des données</h2>
                <p>
                    Nos données sont hébergées prioritairement dans l'Union européenne ou en Suisse. Nous ne
                    transférons jamais vos données à des tiers commerciaux.
                </p>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">6. Durée de conservation</h2>
                <p>
                    Vos données sont conservées le temps de la relation commerciale, puis archivées conformément
                    aux exigences légales suisses (10 ans pour les données comptables).
                </p>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">7. Vos droits</h2>
                <p>Conformément à la nLPD et au RGPD, vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside space-y-2">
                    <li>Droit d'accès à vos données</li>
                    <li>Droit de rectification</li>
                    <li>Droit à l'effacement (dans les limites légales)</li>
                    <li>Droit à la portabilité</li>
                    <li>Droit d'opposition</li>
                </ul>
                <p>Pour exercer ces droits, contactez-nous directement à l'adresse de la Boucherie Costa.</p>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">8. Cookies</h2>
                <p>
                    Nous utilisons uniquement les cookies techniques strictement nécessaires au fonctionnement
                    de l'Espace Pro (session authentifiée). Aucun cookie de suivi publicitaire n'est déposé.
                </p>

                <h2 className="font-serif text-2xl text-[#D4BC7C] mt-10">9. Sécurité</h2>
                <p>
                    Les mots de passe sont hachés (bcrypt), les échanges sont chiffrés (HTTPS/TLS), et l'accès
                    aux données est strictement limité au personnel autorisé.
                </p>
            </div>
        </section>
    );
}
